import api from '@/api';

const resource = 'merenda/deposito-geral-smae';

export default {
  // criarDepositoDaEscola( data ) {
  //   return api.post( `${resource}`, data );
  // },

  // editarDepositoDaEscola( data ) {
  //   return api.put( `${resource}/${data.identificadordepositoescola}`, data);
  // },

  // deletarDepositoDaEscola( id ) {
  //   return api.delete(`${resource}/${id}`);
  // },

  buscarDepositoDaEscola(dados) {
    return api.get( `${resource}`, { params: dados} );
  }
};
